import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import * as bd from 'react-basic-design';
import { accountApi } from '../../../api/account-api';
import { notify } from '../../../components/basic/notify';
import { T, translate } from '../../../components/basic/text';
import { useWaiting } from '../../../components/basic/use-waiting';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { TProvider } from '../../../i18n';
import { SectionTitle } from '../../../components/ui/section-title';

export const UserChangePassword = ({ model, setModel }) => {
    const formRef = useRef();
    const waiting = useWaiting();

    const onSaveClick = () => {
        if (!formRef.current) return false;
        if (!formRef.current.isValid) return false;
        var values = formRef.current.values;
        waiting.start();

        accountApi
            .changeUserPassword({ ...values, key: model.key })
            .then(() => {
                setModel({ ...model, _id: 'view' });
                notify.info(translate('changes-are-saved'));
            })
            .catch(notify.error)
            .finally(waiting.stop);
    };

    const initialValues = { oldPassword: '', newPassword: '', confirmPassword: '' };

    return (
        <TProvider ns="change-password">
            <div className="container-fluid">
                <SectionTitle title="change-password" />
                <Formik
                    initialValues={initialValues}
                    validationSchema={yup.object({
                        oldPassword: yup.string().required(' '),
                        newPassword: yup
                            .string()
                            .required(' ')
                            .min(6, translate('password-minimum-length-is-6-characters')),
                        confirmPassword: yup
                            .string()
                            .required(' ')
                            .oneOf(
                                [yup.ref('newPassword'), null],
                                translate('passwords-must-match')
                            ),
                    })}
                    innerRef={formRef}
                    onSubmit={onSaveClick}
                >
                    {() => (
                        <Form>
                            <FormikTextField
                                labelWidth={4}
                                label="old-password"
                                name="oldPassword"
                                type="password"
                                handleEnter
                            />
                            <FormikTextField
                                labelWidth={4}
                                label="new-password"
                                name="newPassword"
                                type="password"
                                handleEnter
                            />
                            <FormikTextField
                                labelWidth={4}
                                label="confirm-new-password"
                                name="confirmPassword"
                                type="password"
                                handleEnter
                            />
                            <bd.Flex className="p-e-4" align="center" gap={3} content="end">
                                <bd.Button variant="contained" type="submit">
                                    <span>{<T>save-changes</T>}</span>
                                </bd.Button>

                                <bd.Button
                                    type="button"
                                    variant="outline"
                                    onClick={() => setModel({ ...model, _id: 'view' })}
                                >
                                    <span>{<T>cancel</T>}</span>
                                </bd.Button>
                            </bd.Flex>
                        </Form>
                    )}
                </Formik>
            </div>
        </TProvider>
    );
};
